/**
 * Build styles
 */
require("./index.css").toString();
const { make } = require("./util");

export default class BlockBackgroundTool {
  /**
   * Default colour
   *
   * @public
   * @returns {string}
   */
  static get DEFAULT_COLOR() {
    return "";
  }

  static get isTune() {
    return true;
  }

  getColor() {
    if (
      !!this.settings?.blocks &&
      this.settings.blocks.hasOwnProperty(this.block.name)
    ) {
      return this.settings.blocks[this.block.name];
    }
    if (!!this.settings?.default) {
      return this.settings.default;
    }
    return BlockBackgroundTool.DEFAULT_COLOR;
  }

  constructor({ api, data, config, block }) {
    this.api = api;
    this.block = block;
    this.settings = config;
    this.data = data;
    this.colors = config.options;
    this.patterns = config.patterns || [];
    this.themeDirectory = config.themeDirectory || "";
    this._CSS = {
      wrapper: "cdx-bg-color-picker-settings",
      button: "cdx-color-picker-button",
      span: "cdx-color-picker",
      tuneWrapper: "editor-block-tune",
      tuneTitle: "editor-block-tune-title",
      tuneText: "editor-block-tune-text",
      tuneInput: "editor-block-tune-input",
      tuneContent: "editor-block-tune-content-container",
      patternButton: "cdx-pattern-button",
    };
  }

  wrap(blockContent) {
    this.wrapper = make("div");
    this.wrapper.append(blockContent);
    this.wrapper.style.width = "100%";
    this.wrapper.style.height = "100%";

    this.target = this.wrapper.querySelector(".cdx-text-container");
    if (this.data.bgColor !== "") {
      this.target.classList.add(this.data.bgColor.name);
    } else if (this.data?.pattern !== null) {
      this.target.classList.add(this.data.pattern);
    }

    return this.wrapper;
  }

  render() {
    const wrapper = make("div", [this._CSS.wrapper, this._CSS.tuneWrapper]);
    const label = make("label", [this._CSS.tuneTitle]);
    const content = make("div", [this._CSS.tuneContent]);
    const patternLabel = make("label", [this._CSS.tuneTitle]);
    const patternContent = make("div", [this._CSS.tuneContent]);
    const colorButtons = [];
    const patternButtons = [];

    label.innerText = "Background colour";
    this.colors
      .map((color) => {
        const button = document.createElement("button");
        const span = document.createElement("span");

        button.classList.add(this._CSS.button);
        button.type = "button";
        span.classList.add(this._CSS.span);

        span.style.boxShadow = `${color.value} 0px 0px 0px 15px inset`;
        button.classList.toggle(
          "colorCircleActive",
          color.value === this.data?.bgColor?.value
        );
        button.appendChild(span);
        content.appendChild(button);
        colorButtons.push(button);
        return button;
      })
      .forEach((element, index, elements) => {
        element.addEventListener("click", () => {
          this.data = {
            bgColor: this.colors[index],
            pattern: null,
          };
          if (this.patterns.length > 0 && patternButtons.length > 0) {
            patternButtons.forEach((e) => {
              e.classList.remove("patternActive");
            });
            this.patterns.forEach((pattern) => {
              if (pattern.value === "") {
                if (this.target.classList.contains("pattern-default")) {
                  this.target.classList.remove("pattern-default");
                }
              }
              if (this.target.classList.contains(pattern.value)) {
                this.target.classList.remove(pattern.value);
              }
            });
          }
          elements.forEach((el, i) => {
            el.classList.toggle(
              "colorCircleActive",
              this.colors[i].value === this.data?.bgColor?.value
            );
            this.colors.forEach((e) => {
              if (this.target.classList.contains(e.name)) {
                this.target.classList.remove(e.name);
              }
            });
            this.target.classList.add(this.data?.bgColor?.name);
          });
        });
      });

    wrapper.append(label);
    wrapper.append(content);

    if (this.patterns.length > 0 && this.themeDirectory !== "") {
      patternLabel.innerText = "Pattern:";
      this.patterns.forEach((e) => {
        const patternItem = make("button", this._CSS.patternButton);
        if (this.data?.pattern !== null) {
          if (e.value === "" && this.data?.pattern === "pattern-default") {
            patternItem.classList.add("patternActive");
          } else if (e.value === this.data?.pattern) {
            patternItem.classList.add("patternActive");
          }
        }
        patternItem.style.background = `url(${this.themeDirectory}/dist/images/${e.src})`;
        patternItem.addEventListener("click", () => {
          this.data = {
            bgColor: "",
            pattern: e.value === "" ? "pattern-default" : e.value,
          };
          this.colors.forEach((e) => {
            if (this.target.classList.contains(e.name)) {
              this.target.classList.remove(e.name);
            }
          });
          this.patterns.forEach((e) => {
            if (this.target.classList.contains(e.value)) {
              this.target.classList.remove(e.value);
            }
          });
          colorButtons.forEach((colorButton) => {
            colorButton.classList.remove("colorCircleActive");
          });
          patternButtons.forEach((patternButton) => {
            patternButton.classList.remove("patternActive");
          });
          patternItem.classList.add("patternActive");
          this.target.classList.add(this.data?.pattern);
        });
        patternContent.appendChild(patternItem);
        patternButtons.push(patternItem);
      });
      wrapper.append(patternLabel);
      wrapper.append(patternContent);
    }
    return wrapper;
  }

  save() {
    return this.data;
  }
}
